import React from "react";
import { ArrowRightIcon, KeyRoundIcon } from "lucide-react";
import { book } from "../data/book";
export function Footer() {
  return <footer className="border-t border-line bg-night" data-id="element-51" data-mp="3ggty8ibanj58">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-8 px-6 py-14 text-center md:flex-row md:text-left lg:px-10" data-id="element-52" data-mp="32o48q3wk3w3d">
        <div data-id="element-53" data-mp="36pzeplpfmxnh">
          <p className="font-display text-3xl text-cream" data-id="element-54" data-mp="36nd6djupwe47">
            Shift the odds in your favor.
          </p>
          <p className="mt-2 text-muted" data-id="element-55" data-mp="38qw2zmvrtrp">
            {book.title} by {book.author} · Out {book.releaseDate}
          </p>
        </div>
        <a href={book.preorderUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 whitespace-nowrap rounded-lg bg-gold px-6 py-3.5 font-bold uppercase tracking-wider text-ink transition-colors duration-150 ease-out hover:bg-gold-soft" data-id="element-56" data-mp="3lf57aqtrlpme">
          Pre-order free
          <ArrowRightIcon className="h-4 w-4" data-id="element-57" data-mp="2eyjprl0ekyu3" />
        </a>
      </div>
      <div className="border-t border-line" data-id="element-58" data-mp="3l9k292unj58j">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-6 text-sm text-muted lg:px-10" data-id="element-59" data-mp="3labrlvxno6qd">
          <span className="flex items-center gap-2" data-id="element-60" data-mp="3gca7r8seo3du">
            <KeyRoundIcon className="h-4 w-4 text-gold" strokeWidth={1.75} data-id="element-61" data-mp="3v89fujfim3iz" />
            © 2026 {book.author}
          </span>
          <a href="#top" className="hover:text-cream" data-id="element-62" data-mp="3q7u2hrv8gw10">
            Back to top
          </a>
        </div>
      </div>
    </footer>;
}